module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-shenzhen.41fc4c3c.jpeg";